export default __webpack_public_path__ + "static/jurczak-26fce4505c43079769d96eff72175099.jpg";